

class Collection{
  constructor() {
      // tab 锚点
      this.tabs = document.querySelectorAll('[data-tab-id]')

      // 当前高亮索引
      this.index = 0
      this.lockScroll = false
      this.scrollTop = 0
      this.timer = null

      this._init()

      this.watchScrollEvent = this.watchScrollEvent.bind(this)
      window.addEventListener('scroll', this.watchScrollEvent, false)
      window.onbeforeunload = function() {
          window.removeEventListener('scroll', this.watchScrollEvent)
          this.timer = null
      }
  }
  _init() {
      this.tabs.forEach(it => it.onclick = () => this.handleTabClick(it))

      // blur 按钮
      const blurBtns = document.querySelectorAll('[data-blur-btn]')
      blurBtns.forEach(it => it.onclick = (e) => {
          if(it.classList.contains('active')) {
              it.classList.remove("active")
          } else {
              it.classList.add("active")
          }
          this.blurImageBlock(e)
      })
  }
  // tab 点击事件
  handleTabClick(it) {
      this.tabs.forEach(v => v.classList.remove('active'))
      it.classList.add('active')
      this.lockScroll = true

      const offset = this.scrollToBlock(it)

      this.timer = setInterval(() => {
          if(this.scrollTop.toFixed() === offset.toFixed()) {
              this.lockScroll = false
              clearInterval(this.timer)
          }
      }, 50)
  }
  // 滚动到 对应的 DOM
  scrollToBlock(it) {
      const parentHeight = it.parentNode.offsetHeight
      const tab = it.dataset.tabId
      const offsetTop = tab && document.querySelector(`#${tab}`)?.offsetTop

      window.scrollTo({
          top: offsetTop - parentHeight,
          behavior: 'smooth',
      })

      return offsetTop - parentHeight
  }
  // 监听滚动事件
  watchScrollEvent() {
      this.scrollTop = document.documentElement.scrollTop || document.body.scrollTop

      let offsetTopArray = []
      this.tabs.forEach(it => {
          const parentHeight = it.parentNode.offsetHeight
          const tab = it.dataset.tabId
          const offsetTop = tab && document.querySelector(`#${tab}`)?.offsetTop
          offsetTopArray.push(offsetTop - parentHeight)
      })

      !this.lockScroll && this.highlightTab(offsetTopArray)
  }
  // 高亮 tab
  highlightTab(offsetTopArray = []) {
      if (this.scrollTop >= offsetTopArray[this.index + 1]) {
          this.index += 1
      }

      if (this.scrollTop < offsetTopArray[this.index]) {
          this.index = this.index === 0 ? 0 : this.index - 1
      }

      this.tabs.forEach(it => it.classList.remove('active'))
      this.tabs[this.index].classList.add('active')
  }
  // 毛玻璃效果
  blurImageBlock(e) {
      let blurParentDOM = null
      if (e.target.tagName.toUpperCase() === 'I') {
          blurParentDOM = e.target.parentNode.parentNode
      } else {
          blurParentDOM = e.target.parentNode
      }
      if (blurParentDOM.classList.contains('active')) {
          blurParentDOM.classList.remove('active')
      } else {
          blurParentDOM.classList.add('active')
      }
  }
}

export default Collection